export const employmentRegimeOptions = [
  { value: 'monthly', label: 'Mensual' },
  { value: 'daily_24', label: 'Jornalero 24' },
];

export const restPolicyOptions = [
  { value: 'standard_6', label: '6 libres / mes' },
  { value: 'reponedor_4', label: 'Reponedor 4 libres / mes' },
];

export const assignmentModeOptions = [
  {
    value: 'regular',
    label: 'Regular',
    description:
      'Turnos rotativos según la planificación del equipo. En estaciones que rotan cada quince días, la persona rota entre los turnos principales de la estación.',
  },
  {
    value: 'fixed_schedule',
    label: 'Horario fijo semanal',
  },
  {
    value: 'restricted_rotation',
    label: 'Rotación restringida',
    description: 'Rota entre los turnos seleccionados.',
  },
  {
    value: 'occasional',
    label: 'Ocasional',
    description:
      'No se le asigna ningún turno. Se le podrá asignar uno manualmente desde el calendario en los días que vaya a trabajar.',
  },
];

export const suggestRestPolicyFromWorkarea = (primaryWA) => {
  const area = (primaryWA?.positionName || '').trim().toUpperCase();
  const role = (primaryWA?.roleName || '').trim().toUpperCase();

  if (area === 'MINIMERCADO' && role === 'REPONEDOR') {
    return 'reponedor_4';
  }

  return 'standard_6';
};
